import React, { useState, useEffect, useRef } from "react";
import "./Dropdown.css";
import { Link } from "react-router-dom";
import messageIcon from "../../assets/message.png";
import handshakeIcon from "../../assets/handshake.png";
import logoutIcon from "../../assets/logout.png";
import userIcon from "../../assets/user.png";
import userDefaultPic from "../../assets/perfilPic.png";
import RequestSvc from "../../services/RequestSvc"; 
import { BASE_API_URL } from "../../utils/Constants"
import { logout } from '../../api/api'

function getRandomNumber() {
  return Math.floor(Math.random() * (8000 - 1000 + 1)) + 1000;
}

const Dropdown = () => {
  const getUserFromLS = localStorage.getItem("user");
  const [showDropDown, setShowDropDown] = useState(false);
  const [user, setUser] = useState({});
  const dropdownRef = useRef(null);


  const fetchUserData = async () => {
    let svc = new RequestSvc();
    let result = await svc.get(`${BASE_API_URL}userProfile`).catch((err) => console.log(err));
    if (result?.error) {
      console.log("Failed to fetch user data");
    } else {
      setUser(result?.data);
      // Optionally increment imageVersion here if needed
    }
    
  };

  

  const handleDropDown = (url) => {
    setShowDropDown(false); // Cerrar el dropdown después de la navegación
    if (url) {
      window.location.href = url; // Redirigir a la URL especificada
    }
  }

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropDown(false);
    }
  }

  const handleLogout = () => {
    setShowDropDown(!showDropDown);
    logout()
    window.location.href = 'https://clicspy.com/login/?token=expired&session=end';
    
}


  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  /* loading user data  */
  useEffect(() => {
    fetchUserData();
  }, []);

  


  return (
    <div className="dropdownWrapper" ref={dropdownRef}>
      <div className="userImage">
      <img src={user?.Foto ? `${user.Foto}?v=${getRandomNumber()}` : userDefaultPic} alt="" onClick={() => setShowDropDown(!showDropDown)} />
      </div>
      {
        showDropDown &&
        <div className="dropdown">
          <div>
            <div className="usersSection">
              <img src={user?.Foto ? `${user.Foto}?v=${getRandomNumber()}` : userDefaultPic} alt="" />
              {/* <img src={userDefaultPic} alt="" /> */}
              <div className="nameEmail">
                <h6>{user?.Nombre} {user?.Apellido}</h6>
                <p>{user?.Email}</p>
              </div>
            </div>
            <div className="dropdownMenu">
              <div className="dropdownItems" style={{ cursor: 'pointer' }}>
              <div onClick={() => handleDropDown('https://clicspy.com/profile/')}>
                  <img src={userIcon} alt="" />
                  Mi cuenta
                </div>
                <div onClick={() => handleDropDown('https://clicspy.com/convierteenafiliado')}>
                  <img src={handshakeIcon} alt="" />
                  Conviértete en afiliado
                </div>
               
                <div onClick={handleLogout}>
                  <img src={logoutIcon} alt="" />
                  Salir
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default Dropdown;
